var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ArchivesBooksInner.jinja');
require('./ArchivesBooksInner.less');

module.exports = Base.extend({

    template: template,

    events: {
    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ArchivesBooks/ArchivesBooksInner.js
// module id = 154
// module chunks = 0